<script setup>
defineProps({
    show: {
        type: Boolean
    },
    message: {
        type: String,
        default: ''
    }
});
</script>

<template>
    <v-alert
        v-if="show"
        :text="message ? message : $t('unexpected_error')"
        type="warning"
        variant="tonal"
        density="compact"
        class="text-left"
        dismissible
    >
        <slot></slot>
    </v-alert>
</template>
